'use strict';
angular.module('theme').component('campaignBanner', {
	templateUrl: 'component/campaign-banner.html',
	controller: function($scope, $window, $document, $cookies, CampaignService, TrackerService) {
		var body = angular.element($document[0].body);

		$scope.campaignCode = $cookies.get('campaign-code');
		$scope.showBanner = $cookies.get('hide-campaign-banner') ? $cookies.get('hide-campaign-banner') !== $scope.campaignCode : true;
		if ($scope.showBanner) {
			CampaignService.get($scope.campaignCode).then(function(data) {
				$scope.campaign = data;

				var eventData = {
					'promoView': {
						'promotions': {
							'id': $scope.campaign.campaign_code,
							'name': $scope.campaign.banner_header,
							'slot': 'Fixed bottom'
						}
					}
				};

				TrackerService.ecommerceEvent('promoView', eventData);

				body.addClass('active-announcement-bar');
			});
		}

		$scope.campaignClick = function() {
			var data = {
				'promoClick': {
					'promotions': {
						'id': $scope.campaign.campaign_code,
						'name': $scope.campaign.banner_header,
						'slot': 'Fixed bottom'
					}
				}	
			};

			TrackerService.ecommerceEvent('promoClick', data);

			$window.location.href = $scope.campaign.banner_link;	
		};

		$scope.close = function() {
			$scope.showBanner = false;
			$cookies.put('hide-campaign-banner', $scope.campaignCode, {
				path: '/',
				expires: moment().add(1, 'month').toDate()
			});

			body.removeClass('active-announcement-bar');
		};
	}
});
